import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  headerMonth: function headerMonth(t) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      display: inline-block;\n      line-height: ", ";\n      padding: ", " 0 ", ";\n    "])), t.calendarMonthTitleLineHeight, t.calendarMonthTitlePaddingTop, t.calendarMonthTitlePaddingBottom);
  },
  headerYear: function headerYear(t) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      display: inline-block;\n      position: absolute;\n      right: 0;\n      line-height: ", ";\n      padding: ", " 0 ", ";\n    "])), t.calendarMonthTitleLineHeight, t.calendarMonthTitlePaddingTop, t.calendarMonthTitlePaddingBottom);
  },
  month: function month(t) {
    var width = parseInt(t.calendarCellSize) * 7;
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      position: absolute;\n      width: ", "px;\n    "])), width);
  },
  header: function header() {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      position: relative;\n    "])));
  },
  headerSticky: function headerSticky(t) {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      background-color: ", ";\n      z-index: 2;\n    "])), t.calendarMonthHeaderStickedBgColor);
  },
  monthTitle: function monthTitle(t) {
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n      border-bottom: 1px solid ", ";\n      font-weight: ", ";\n      margin: 0 ", " ", ";\n    "])), t.calendarMonthTitleBorderBottomColor, t.dateSelectFontWeight, t.calendarMonthTitleMarginX, t.calendarMonthTitleMarginBottom);
  }
});